import { Button } from "components/atoms/button/button";
import styled from "styled-components";

export const CMBModalWrapper = styled.div`
  text-align: center;
  padding-top: 1rem;
`;

export const CMBHeading = styled.p`
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  line-height: 36px;
  margin: 0;
  text-align: center;
`;

export const CMBSubHeading = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.neutral[600]};
  font-family: ${({ theme }) => theme.fonts.secondary};
  margin: 0;
`;

export const StyledButton = styled(Button)`
  font-size: ${({ theme }) => theme.fontSizes.md};
  display: inline-block;
  margin: auto;
  width: 320px;
`;

export const CMBInfoText = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.lg};
  font-family: ${({ theme }) => theme.fonts.secondary};
  margin: 0;
`;

export const CMBNumber = styled.span`
  font-weight: bold;
`;
